import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoEstabelecimento } from '../../servicos/srv.rede';

@Component({
  selector: 'tsv2-stb-visualizar',
  templateUrl: './visualizar.component.html',
  providers: [ ServicoMsg, ServicoEstabelecimento ]
})
export class EstabelecimentoVisualizarComponent implements OnInit {
  exibirBarra: boolean = true;

  p: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoEstabelecimento: ServicoEstabelecimento
  ) { }

  ngOnInit() {
    this.spinner.show();
    const id = this.route.snapshot.params['id'];
    this.servicoEstabelecimento.consultarEstabelecimento(id).subscribe(res => {
      this.p = res.lista[0];
      this.spinner.hide();
    }, (err) => {
      this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

  removerEstabelecimento(id){
    let titulo = 'Remover o estabelecimento?';
    let url = '/estabelecimento/pesquisar/';
    let texto = 'Estabelecimento removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoEstabelecimento, texto).then(r1 => {
      if (r1.success){
        this.router.navigate([url]);
      }
    }, (err: any) => {
      this.spinner.hide();
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
